import { Fragment } from 'react';
import { Typography, Grid, Box, Stack } from '@mui/material';
import Form from 'components/Form';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  {
    label: '高血壓',
    key: 'no1_2.checked1',
  },
  {
    label: '糖尿病',
    key: 'no1_2.checked2',
  },
  {
    label: '肝病',
    key: 'no1_2.checked3',
  },
  {
    label: '結核病',
    key: 'no1_2.checked4',
  },
  {
    label: '心臟病',
    key: 'no1_2.checked5',
  },
  {
    label: '腎病',
    key: 'no1_2.checked6',
  },
  {
    label: '呼吸系統疾病',
    key: 'no1_2.checked7',
  },
  {
    label: '過敏',
    key: 'no1_2.checked8',
  },
  {
    label: '出血傾向',
    key: 'no1_2.checked9',
  },
  {
    label: '其他',
    key: 'no1_2.checked10',
  },
];

const PatientInfo = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="1. 患者當前狀況" />

      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        <Typography
          sx={{ lineHeight: '20px', fontSize: '14px', marginBottom: '10px' }}
        >
          1) 診斷名稱
        </Typography>
        <Form.MuiTextField
          required={false}
          disabled={disabled}
          {...register('no1_1')}
        />
        <Typography
          sx={{
            lineHeight: '20px',
            margin: '0px 0 0 0px',
            fontSize: '14px',
            marginTop: '10px',
          }}
        >
          2) 病史
        </Typography>
        <Grid container xs={12}>
          {checks.map((v, i) => {
            if (v.label === 'etc') {
              return (
                <Grid item xs={2.4}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                    <Form.MuiTextField
                      required={false}
                      sx={{ width: '120px', marginLeft: '20px' }}
                      disabled={disabled}
                      placeholder="输入"
                      {...register('no1_3')}
                    />
                  </Stack>
                </Grid>
              );
            }
            return (
              <Grid item xs={2.4}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default PatientInfo;
